export default __webpack_public_path__ + "images/HLF_Stor_logga_960497e9c34c7eacc0d0f2fdb4badfc9.svg";